import styled from 'styled-components';
import { light, dark } from '@mlb/play-ui';

export enum FeaturedIconBorders {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface FeaturedIconProps
  extends Omit<React.ComponentProps<'img'>, 'ref'> {
  border?: FeaturedIconBorders;
}

const borders = {
  light: `1px solid ${light.iconBorderColor}`,
  dark: `1px solid ${dark.iconBorderColor}`,
};

const StyledFeaturedIcon = styled.img<FeaturedIconProps>`
  width: 100%;
  height: 100%;
  ${({ border }) =>
    border &&
    `
    border: ${borders[border]};
    border-radius: 0.5rem;
  `};
`;

export const FeaturedIcon = ({ src, ...rest }: FeaturedIconProps) =>
  src && <StyledFeaturedIcon src={src} {...rest} />;

export default FeaturedIcon;
